import { useRef } from 'react';
import { useI18nContext } from '@/i18n/i18n-react';
import { Header } from '@/layouts/centered-content.layout';
import { cn } from '@/lib/utils';
import { CreateAudienceButton } from '@/components/audiences/create-audience-button';
import { useScrollDetection } from '@/components/audiences/hooks/use-scroll-detection';

interface AudienceListHeaderProps {
  tenantSlug: string;
  showCreateButton?: boolean;
}

export function AudienceListHeader({
  tenantSlug,
  showCreateButton = true,
}: AudienceListHeaderProps) {
  const { LL } = useI18nContext();
  const headerRef = useRef<HTMLDivElement>(null);
  const isScrolled = useScrollDetection(headerRef);

  return (
    <Header
      className={cn(
        isScrolled &&
          'pb-2 mb-4 lg:mb-8 transition-[padding,margin] duration-200'
      )}
    >
      <div ref={headerRef} className="flex items-start justify-between gap-4">
        <div className="flex min-w-0 flex-col gap-1">
          <h1 className="text-lg tracking-tight sm:text-xl">
            {LL.audiences.title()}
          </h1>
          <div
            className={cn(
              'grid transition-[grid-template-rows,opacity,margin] duration-200 ease-out',
              isScrolled
                ? 'grid-rows-[0fr] opacity-0 -mt-1'
                : 'grid-rows-[1fr] opacity-100'
            )}
          >
            <div className="overflow-hidden">
              <p className="max-w-2xl text-muted-foreground text-sm">
                {LL.audiences.emptyStateDescription()}
              </p>
            </div>
          </div>
        </div>
        {showCreateButton && <CreateAudienceButton tenantSlug={tenantSlug} />}
      </div>
    </Header>
  );
}
